'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaultExport = new String('.header{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;margin:13px 16px 12px;}.name{font-size:16px;font-weight:bold;color:#ffffff;margin:8px;}');

_defaultExport.__hash = '1365415295';
_defaultExport.__scoped = '.header.jsx-1213094334{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;margin:13px 16px 12px;}.name.jsx-1213094334{font-size:16px;font-weight:bold;color:#ffffff;margin:8px;}';
_defaultExport.__scopedHash = '1213094334';
exports.default = _defaultExport;
var headshotCss = exports.headshotCss = '\n  .headshot {\n    height: 36px;\n    width: 36px;\n    border-radius: 50%;\n  }\n';